export const GET_SUBJECTDATA = 'GET_SUBJECTDATA';
export const GET_TYPEDATA = 'GET_TYPEDATA';
export const GET_SCOREDATA = 'GET_SCOREDATA'

